// extracted by mini-css-extract-plugin
export default {"textElementBox":"Board_textElementBox__Jx-hy"};